export default "__VITE_ASSET__qHCHbZ13__"